const preselectVariantFromURL = ({
  variantsData,
  optionNames,
  form,
  selectedOptions,
  sellingPlanIdInput,
  updateVariantDetails
}) => {
  const url = new URL(window.location.href);
  const variantIdFromURL = url.searchParams.get('variant');
  if (!variantIdFromURL) return;

  const variant = variantsData.find(v => String(v.id) === variantIdFromURL);
  if (!variant) return;

  optionNames.forEach((name, i) => {
    const value = variant[`option${i + 1}`];
    selectedOptions[name] = value;

    const escName = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(name) : name;
    const escValue = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(value) : value;
    const input = form.querySelector(`input[name="${escName}"][value="${escValue}"]`);
    if (input) {
      input.checked = true;
    } else {
      const select = form.querySelector(`select[name="${escName}"]`);
      if (select) select.value = value;
    }
  });

  const qty =
    typeof variant.inventory_quantity === 'number' && !Number.isNaN(variant.inventory_quantity)
      ? variant.inventory_quantity
      : 0;
  updateVariantDetails(qty, false);

  if (sellingPlanIdInput && url.searchParams.get('selling_plan')) {
    const sellingPlanFromURL = url.searchParams.get('selling_plan');
    sellingPlanIdInput.value = sellingPlanFromURL;
    const sellingPlanInputRadio = form.querySelector(`[data-selling-plan-radio][value="${sellingPlanFromURL}"]`);
    if (sellingPlanInputRadio) {
      sellingPlanInputRadio.checked = true;
    }
    updateVariantDetails(qty, false);
  }
};

export default preselectVariantFromURL;
